import { sum } from 'es-toolkit';
import { hasStocksAnalytics } from './configUtils';

/**
 * Calculate total stocks portfolio value.
 * Uses analytics data (combinedOverallAnalysis) when available for analytics tenants,
 * falls back to raw data sum.
 */
export const getStocksTotalValue = (
  equitiesETFData: any,
  data: any,
  stocksData: any[],
): number => {
  if (hasStocksAnalytics()) {
    const analyticsVal =
      equitiesETFData?.data?.combinedOverallAnalysis?.totalPortfolioValue;
    if (analyticsVal) return analyticsVal;
  }
  if (data?.current?.totalPortfolioValue) {
    return data?.current?.totalPortfolioValue;
  }
  const currentValues =
    stocksData?.map((stock: any) =>
      Number(
        stock?.rawData?.Summary?.currentValue
          ? stock?.rawData?.Summary?.currentValue
          : 0,
      ),
    ) ?? [];
  return Number(sum(currentValues).toString());
};